import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ChangePassword2Component } from './components/change-password2/change-password2.component';
import { ChangePasswordMainComponent } from './pages/change-password-main/change-password-main.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { RouterModule, Routes } from '@angular/router';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'primeng/api';
import { CalendarModule } from 'primeng/calendar';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { RatingModule } from 'primeng/rating';
import { TabViewModule } from 'primeng/tabview';
import { TooltipModule } from 'primeng/tooltip';
import { CardsModule } from 'src/app/_metronic/partials';

const routes: Routes = [
  {
    path: '',
    component: ChangePasswordMainComponent,
  },
];


@NgModule({
  declarations: [ChangePassword2Component, ChangePasswordMainComponent],
  exports: [
    ChangePassword2Component
  ],
  imports: [
    CommonModule,
    SharedModule,
    TooltipModule,
    DropdownModule,
    CalendarModule,
    RatingModule,
    MultiSelectModule,
    TooltipModule,
    RouterModule.forChild(routes),
    InputTextModule,
    ReactiveFormsModule,
    TranslateModule,
    TabViewModule,
    FormsModule,
    CardsModule,
    NgbAccordionModule,
    SharedModule,
  ]
})
export class ChangePasswordModule { }
